<template>
  <el-form
      ref="form"
      :model="form"
      :inline="true"
      hide-required-asterisk
      :show-message="true">
    <gj-table
        :index="false"
        :show-header="false"
        name="operationLogContentPicker"
        :data="form.contentItems"
        :columns="columns"
        border="none"
        :adapt-height="false"
        errorColumn
        >
      <template v-slot:date="{ index }">
        <el-form-item
            :prop="`contentItems.${index}.date`"
            :rules="[
            { required: true, message: '请选择日期', trigger: ['change'] },
          ]"
            class="gj-table-item">
          <gj-date-picker
              v-model="form.contentItems[index].date"
              width="200px"
              placeholder="日志日期"
              :clearable="false"
          ></gj-date-picker>
        </el-form-item>
      </template>
      <template v-slot:type="{ index }">
        <el-form-item
            :prop="`contentItems.${index}.type`"
            :rules="[
            { required: true, message: '请选择日志类型', trigger: ['change'] },
          ]"
            class="gj-table-item">
          <gj-select
              v-model="form.contentItems[index].type"
              width="200px"
              placeholder="日志类型"
              :options="option.type"
              :clearable="false">
          </gj-select>
        </el-form-item>
      </template>
      <template v-slot:content="{ index }">
        <el-form-item
            :prop="`contentItems.${index}.content`"
            :rules="[
            { required: true, message: '请输入内容', trigger: ['change'] },
          ]"
            class="gj-table-item">
          <gj-textarea
              v-model="form.contentItems[index].content"
              rows="1"
              placeholder="日志内容"
              :clearable="false"
              :styles="{width: '660px'}"
          ></gj-textarea>
        </el-form-item>
      </template>
      <template v-slot:op="{ index }">
        <!-- <gj-button
            v-if="index !== 0"
            type="danger"
            icon="el-icon-minus"
            size="mini"
            circle
            style="padding: 2px;"
            @click="deleteItem(index)">
        </gj-button>
        <gj-button
            v-else
            type="default"
            icon="el-icon-plus"
            size="mini"
            circle
            style="padding: 2px;"
            @click="addItem(index)">
        </gj-button> -->
        <gj-button
            v-if="index !== 0"
            type="iconfont"
            iconfont="iconjianshao"
            size="16px"
            @click="deleteItem(index)">
        </gj-button>
        <gj-button
            v-else
            type="iconfont"
            iconfont="iconzengjia"
            size="16px"
            @click="addItem(index)">
        </gj-button>
      </template>
    </gj-table>
  </el-form>
</template>

<script>
  import {getDictionaryCombobox} from "../../../../../../../api/common";
  import {formRuleMixin} from "../../../../../../../minxins";

  export default {
    name: "app-operation-log-content-picker",
    mixins: [formRuleMixin],
    props: {
      form: {
        required: true
      }
    },
    data() {
      return {
        columns: [
          {id: 'date', header: '', field: 'slot:date', width: '220px'},
          {id: 'type', header: '', field: 'slot:type', width: '220px'},
          {id: 'content', header: '', field: 'slot:content', minWidth: '120px'},
          {id: 'op', header: '', field: 'slot:op', width: '40px'},
        ],
        option: {
          typeLoading: false,
          type: []
        }
      }
    },
    created() {
      this.getTypeOption();
      this.addItem();
    },
    methods: {
      getTypeOption() {
        this.option.typeLoading = true;
        getDictionaryCombobox('OPERATION_LOG_TYPE')
          .then((data) => {
            this.option.type = data;
          })
          .complete(() => this.option.typeLoading = false);
      },
      addItem(index) {
        this.form.contentItems.unshift({
          date: null,
          type: null,
          content: null
        });
      },
      deleteItem(index) {
        this.form.contentItems.splice(index, 1);
      },
    }
  }
</script>

<style lang="scss" scoped>
.el-button--mini{
  border-width: 1px!important;
}
.el-button--danger{
  border-color: #f56c6c!important;
}
/deep/ .el-textarea__inner{
  min-height: 32px !important;
}
</style>
